import CategoryPage from './CategoryPage';

const IluminacaoPage = () => <CategoryPage category="iluminacao" />;

export default IluminacaoPage;
